export default {"src":"/_next/static/media/video.0e0c3437.svg","height":26,"width":38};